// For production, use Heroku backend API, for development use localhost
export const serverURL = process.env.NODE_ENV === 'production' ? 'https://clip-digest.herokuapp.com' : 'http://localhost:3000'